const schema = [
        ['name'],
        ['dateTime'],
        ['type'],
        ['doneAt'],
        ['project'],
];

export default schema;
